import React from 'react';

import SwitchButton from '@app/components/UI/SwitchButton';

import '@app/scss/components/availabilitySwitcherButton.scss';

enum FilterState {
	Available,
	NonAvailable
}

interface AvailabilitySwitcherButtonProps {
	onSwitch: (state: FilterState) => void;
	defaultChecked?: boolean;
}

const AvailabilitySwitcherButton: React.FC<AvailabilitySwitcherButtonProps> = ({ onSwitch, defaultChecked }) => {
	return (
		<SwitchButton
			index={defaultChecked ? 0 : 1}
			switchOrder={[FilterState.Available, FilterState.NonAvailable]}
			className={(state) => `btn-na ${state === FilterState.Available ? '' : 'non-'}active`}
			onClick={(state) => onSwitch(state)}
		>
			{(state) => 'N/A'}
		</SwitchButton>
	);
};

export default AvailabilitySwitcherButton;
